// extracted by mini-css-extract-plugin
export default {"Specifications":"H9dhZiT0E1vS528P1NaB"};